
import { user_common_tradeKind } from '@/api/user'

const state = {
  quantityUnitKey: {
    pingfangmi: '平方米',
    mu: '亩',
    liang: '辆',
    tai: '台',
    dun: '吨',
    qianke: '千克'
  }, // 转出面积key
  tradeKindKey: {
    construction: '集体经营性建设用地',
    house: '农村宅基地',
    farmland: '农村土地承包经营权'
  },
  planningKey: {
    0: '符合',
    1: '其他'
  },
  whethers: [{ value: 1, label: '是' }, { value: 0, label: '否' }],
  whether: {
    1: '是',
    0: '否'
  },
  transfereeType: {
    0: '个人',
    1: '集体',
    2: '企业',
    3: '合作社'
  },
  // 交易方式
  tradeModeKey: {
    0: '公开协商',
    // 1: '预挂牌',
    2: '历史备案',
    3: '公开竞价',
    4: '续约交易',
    5: '小额简易'
  },
  tradeModes: [
    {
      key: '3',
      value: '公开竞价'
    },
    {
      key: '0',
      value: '公开协商'
    },
    {
      key: '5',
      value: '小额简易'
    },
    // {
    //   key:'1',
    //   val:'预挂牌'
    // },
    {
      key: '4',
      value: '续约交易'
    },
    {
      key: '2',
      value: '历史备案'
    }
  ],
  landStateKey: {
    0: '国有',
    1: '集体'
  },
  equitiesKey: {
    all: '所有权',
    use: '使用权',
    lease: '租赁权',
    earnings: '收益'
  },

  slopeKey: {
    huanpo: '缓坡',
    doupo: '陡坡',
    pingpo: '平坡',
    xiepo: '斜坡',
    jipo: '急坡',
    jidoupo: '急陡坡',
    xianpo: '险坡'
  },
  sourceKey: {
    rengong: '人工林',
    ziran: '自然林'
  },
  speciesKey: {
    yongcai: '用材林地',
    fanghu: '防护林地',
    xintan: '薪炭林地',
    teyong: '特用林地',
    jingji: '经济林地',
    zhu: '竹林地',
    caidaijidi: '采代迹地',
    guanmu: '灌木林地',
    shu: '疏林地',
    weichenglinzhao: '未成林造林地'
  },
  treeSpeciesKey: {
    yang: '杨树',
    song: '松树',
    yunnan: '云南松',
    mawei: '马尾松',
    qita: '其他'
  },
  paymentModeKey: {
    0: '一次性支付',
    1: '按年支付',
    2: '按约定支付,分次支付',
    3: '按月支付',
  },
  priceUnitKey: {
    yearjia: '元/年',
    zongjia: '元',
    mianyi: '面议',
    monthjia: '元/月',
    danjia: '元/{数量单位}/年（单价）'
  },
  delayKey: {
    0: '不延时',
    '-1': '延至征集到受让方',
    3: '延时三天',
    7: '延时七天'
  },
  auctionModeKey: {
    0: '阶梯竞价',
    1: '自由竞价'
  },
  deadlineUnitKey: {
    0: '年',
    1: '月',
    2: '天'
  },
  // 资金性质
  capitalPropertyKey: {
    'zichou': '自筹',
    'qita': '其他',
    'guoyou': '国有',
    'jiti': '集体'
  },
  capitalSourceKey: {
    'caizheng': '财政',
    'nongwei': '农委',
    'kewei': '科委',
    'fagai': '发改',
    'zichou': '自筹',
    'qita': '其他'
  },
  // 资产现状
  actualityKey: {
    'xianzhi': '闲置',
    'zhanyong': '占用',
  },
  // 招标类型key
  biddingTypeKey: {
    'service': '服务类',
    'epc': '工程类',
    'goods': '货物类'
  },
  tradeKindList: [], // 交易品种列表
  directionKey: {
    positive: '正向',
    reverse: '反向'
  },

  bidCountKey: {
    1: '一次出价',
    0: '多次出价'
  },
  /**
   * 资产用途
   */
  assetPurposeKey: {
    '01': '农业',
    '02': '工业',
    '03': '商业',
    '04': '建设',
    '05': '居住',
    '06': '自用',
    '99': '其他'
  },
  // 项目状态
  stateList: [
    {
      key: '0',
      value: '预告中'
    },
    {
      key: '1',
      value: '报名中'
    },
    {
      key: '2',
      value: '报名截止'
    },
    {
      key: '3',
      value: '竞拍中'
    },
    {
      key: '4',
      value: '已终止'
    },
    {
      key: '5',
      value: '已成交'
    }
  ],
  // 除公开竞价之外的交易方式下的项目状态
  stateKey: {
    0: '暂存中',
    1: '待审核',
    2: '审核不通过',
    3: '待交易',
    4: '已交易',
    5: '报名中',
    6: '待确认',
    7: '已流拍',
    8: '已终止',
    10: '已弃拍'
  },
  // 各种交易模式下的所有状态定义
  stateListAll: {
    // 公开协商
    '0': [
      // {
      //   key: '0',
      //   value: '暂存中'
      // },
      // {
      //   key: '1',
      //   value: '待审核'
      // },
      // {
      //   key: '2',
      //   value: '审核不通过'
      // },
      {
        key: '5',
        value: '报名中'
      },
      {
        key: '11',
        value: '项目审核中'
      },
      {
        key: '6',
        value: '待确认'
      },
      {
        key: '3',
        value: '待交易'
      },
      {
        key: '4',
        value: '已交易'
      },
      {
        key: '7',
        value: '已流拍'
      },
      {
        key: '8',
        value: '已终止'
      },
      {
        key: '10',
        value: '已弃拍'
      }
    ],
    '1': [], // 预挂牌
    '2': [// 历史备案
      // {
      //   key: '1',
      //   value: '待审核'
      // },
      {
        key: '3',
        value: '待交易'
      },
      {
        key: '4',
        value: '已交易'
      }
    ],
    '3': [// 公开竞价
      // {
      //   key: '1',
      //   value: '待审核'
      // },
      {
        key: '3',
        value: '预告中'
      },
      {
        key: '4',
        value: '报名中'
      },
      {
        key: '5',
        value: '报名截止'
      },
      {
        key: '6',
        value: '竞价中'
      },
      {
        key: '9',
        value: '已成交'
      },
      {
        key: '7',
        value: '已流拍'
      },
      {
        key: '8',
        value: '已终止'
      },
      {
        key: '10',
        value: '已弃拍'
      }
    ],
    // 续约交易
    '4': [
      // {
      //   key: '0',
      //   value: '暂存中'
      // },
      // {
      //   key: '1',
      //   value: '待审核'
      // },
      // {
      //   key: '2',
      //   value: '审核不通过'
      // },
      {
        key: '6',
        value: '待确认'
      },
      {
        key: '3',
        value: '待交易'
      },
      {
        key: '4',
        value: '已交易'
      },
      {
        key: '7',
        value: '已流拍'
      },
      {
        key: '8',
        value: '已终止'
      },
      {
        key: '10',
        value: '已弃拍'
      }
    ],
    // 小额简易交易
    '5': [
      // {
      //   key: '0',
      //   value: '暂存中'
      // },
      // {
      //   key: '1',
      //   value: '待审核'
      // },
      // {
      //   key: '2',
      //   value: '审核不通过'
      // },
      {
        key: '5',
        value: '报名中'
      },
      {
        key: '3',
        value: '待交易'
      },
      {
        key: '4',
        value: '已交易'
      },
      {
        key: '7',
        value: '已流拍'
      },
      {
        key: '8',
        value: '已终止'
      },
      {
        key: '10',
        value: '已弃拍'
      }
    ]
  },
  transferModes: [
    {
      key: 'chuzu',
      value: '出租'
    },
    {
      key: 'zhuanrang',
      value: '转让'
    },
    {
      key: 'huhuan',
      value: '互换'
    },
    {
      key: 'rugu',
      value: '入股'
    },
    {
      key: 'hezuo',
      value: '合作'
    },
    {
      key: 'qita',
      value: '其他'
    }
  ],
  stateAllKey: {
    '0': {
      '11': '项目审核中',
      '0': '暂存中',
      '1': '待审核',
      '2': '审核不通过',
      '3': '待交易',
      '4': '已交易',
      '5': '报名中',
      '6': '待确认',
      '7': '已流拍',
      '8': '已终止',
      '10': '已弃拍'
    },
    '2': {
      '3': '待交易',
      '4': '已交易'
    },
    '3': {
      '3': '预告中',
      '4': '报名中',
      '5': '报名截止',
      '6': '竞价中',
      '7': '已流拍',
      '8': '已终止',
      '9': '已成交',
      '10': '已弃拍'
    },
    '4': {
      '0': '暂存中',
      '1': '待审核',
      '2': '审核不通过',
      '3': '待交易',
      '4': '已交易',
      '6': '待确认',
      '7': '已流拍',
      '8': '已终止',
      '10': '已弃拍'
    },
    '5': {
      '0': '暂存中',
      '1': '待审核',
      '2': '审核不通过',
      '3': '待交易',
      '4': '已交易',
      '5': '报名中',
      '7': '已流拍',
      '8': '已终止',
      '10': '已弃拍'
    }
  },

  target_type_operating: {
    maps: {
      'fangwu': '房屋',
      'jianzhuwu': '建筑物',
      'jiqisheb': '机器设备',
      'nongchanpin': '农产品',
      'qita': '其他',
      'shangpu': '商铺',
      'yunshugongju': '运输工具'
    }
  },
  target_type_forest: {
    maps: {
      'gangmulindi': '灌木林地',
      'sulindi': '疏林地',
      'weichenglinzhaolindi': '未成林造林地',
      'wulindi': '无林地',
      'youlindi': '有林地'
    }
  },
  landKindMap: {
    gengdi: '耕地',
    yuchi: '鱼池',
    kengtangshuimian: '坑塘水面',
    yangzhishuimian: '养殖水面',
    lindi: '林地',
    qita: '其它'
  }
}

const mutations = {

}

const actions = {
  async getTradeKindList({ state }) {
    if (!state.tradeKindList.length) {
      const { data } = await user_common_tradeKind()
      state.tradeKindList = data
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

